"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getProductInfoDialogProducts = require("./getProductInfoDialogProducts");
Object.keys(_getProductInfoDialogProducts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getProductInfoDialogProducts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getProductInfoDialogProducts[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
